import { FC, useCallback } from 'react';
import { $fm } from '@/Intl';
import {
  ReactSortable,
  ItemInterface as SortItemProps,
} from 'react-sortablejs';
import './TaskbarSelect.less';

const tasklist = [
  {
    value: 'wifi',
    title: 'WIFI',
  },
  {
    value: 'bt',
    title: 'BT',
  },
  {
    value: 'gsdnd',
    title: 'GS_DND',
  },
  {
    value: 'gsvoice',
    title: 'GS_VOICE',
  },
  {
    value: 'gslock',
    title: 'GS_LOCK',
  },
  {
    value: 'gsautoanswer',
    title: 'GS_AUTOANSWER',
  },
  {
    value: 'gstransfer',
    title: 'GS_TRANSFER',
  },
  {
    value: 'gsehs',
    title: 'GS_EHS',
  },
  {
    value: 'gsscreenshot',
    title: 'GS_SCREENSHOT',
  },
  {
    value: 'gsnetwork',
    title: 'GS_NETWORK',
  },
  {
    value: 'gsaudio',
    title: 'GS_AUDIO',
  },
];

type Tasklist = typeof tasklist;

// 获取选中和非选中
const getSelectedAndAvailable = (
  value: string,
  defaultTasks: string[],
): [Tasklist, Tasklist] => {
  let selected: Tasklist = [];
  let available: Tasklist = [];
  let tmp = value.split(',');
  let _tasklist = tasklist
    .filter((t) => defaultTasks.includes(t.value))
    .slice();

  tmp.forEach((v) => {
    let x = _tasklist.findIndex((t) => t.value === v);
    if (x > -1) {
      let ts = _tasklist.splice(x, 1)[0];
      selected.push(ts);
    }
  });
  available = _tasklist;
  return [selected, available];
};

interface TaskItemProps {
  value: string;
  title: React.ReactNode | string;
  type: 'del' | 'add';
  onDel?: (...arg: any[]) => void;
  onAdd?: (...arg: any[]) => void;
}

const TaskItem: FC<TaskItemProps> = (props) => {
  const { value, title, type, onDel, onAdd } = props;
  const handleClick = useCallback(() => {
    if (type === 'del' && onDel) {
      onDel(value);
    }
    if (type === 'add' && onAdd) {
      onAdd(value);
    }
  }, [type, onDel, onAdd, value]);
  return (
    <div className='task-item'>
      <i className={`task-icon icon-${value}`} /> <br />
      <span>{title}</span>
      <em className={`operate-icon ${type}`} onClick={handleClick}></em>
    </div>
  );
};

const TaskbarSelect: FC<CustomFieldsProps & { defaultTasks: string }> = (
  props,
) => {
  const { value = '', onChange, defaultTasks } = props;
  const [selected, available] = getSelectedAndAvailable(
    value,
    defaultTasks.split(','),
  );

  // 删除
  const handleDel = useCallback(
    (i: number) => {
      let tmpSelected = selected.slice();
      tmpSelected.splice(i, 1);
      onChange && onChange(tmpSelected.map((task) => task.value).join(','));
    },
    [onChange, selected],
  );

  // 添加
  const handleAdd = useCallback(
    (i: number) => {
      let tmpSelected = selected.slice();
      tmpSelected.push(available[i]);
      onChange && onChange(tmpSelected.map((task) => task.value).join(','));
    },
    [available, onChange, selected],
  );

  // handleSort
  const handleSort = useCallback(
    (list: SortItemProps[]) => {
      onChange && onChange(list.map((item) => item.id).join(','));
    },
    [onChange],
  );

  return (
    <div className='taskbar-select'>
      <div className='selected-items'>
        <h4>{$fm('TASK_TITLE1')}</h4>
        <div className='items-box'>
          <div className='items-box-tip'>{$fm('TASKBOX_PROMPT1')}</div>
          <ReactSortable
            className='items-box-content'
            list={selected.map(({ value, title }) => ({
              id: value,
              name: title,
            }))}
            setList={(list) => handleSort(list)}
            animation={300}
            easing='cubic-bezier(1, 0, 0, 1)'
          >
            {selected.map((t, i) => (
              <TaskItem
                key={t.value}
                value={t.value}
                title={$fm(t.title)}
                type='del'
                onDel={() => handleDel(i)}
              />
            ))}
          </ReactSortable>
        </div>
      </div>
      {available.length > 0 ? (
        <div className='available-items'>
          <h4>{$fm('TASK_TITLE2')}</h4>
          <div className='items-box'>
            <div className='items-box-tip'>{$fm('TASKBOX_PROMPT2')}</div>
            <div className='items-box-content'>
              {available.map((t, i) => (
                <TaskItem
                  key={t.value}
                  value={t.value}
                  title={$fm(t.title)}
                  type='add'
                  onAdd={() => handleAdd(i)}
                />
              ))}
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default TaskbarSelect;
